import { Routes } from '@angular/router';
import { MainComponent } from './containers/main/main.component';

export const MA_ROUTES: Routes = [
  {
    path: '',
    component: MainComponent,
  },
];
